import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder";
import { CardData } from "../../types/card.type";
import { User2 } from "lucide-react";

interface AllCardsEquipmentProps {
  card: CardData;
}

const AllCardsEquipment = ({ card }: AllCardsEquipmentProps) => {
  return (
    <div className="flex items-center gap-2 w-max">
      <ImageWithPlaceholder
        className="w-6 h-6"
        iconClassName="w-4 h-4"
        placeholderIcon={User2}
        url={card.equipment?.photos?.[0]?.url}
      />

      <div className="flex flex-col">
        <div className="flex items-center gap-4">
          <p>{card.equipment?.official_name || card.equipment?.license_plate}</p>
          <p className="text-xs font-light text-yellow-400 italic">Via: {card.copy_number}</p>
        </div>
        <p className="text-[11px] font-light text-white-300 italic">Equipamento</p>
      </div>
    </div>
  );
};

export default AllCardsEquipment;
